module.exports = __webpack_public_path__ + "static/media/icon_team.fb13e4b7.png";